const QTY_EPS = 0.0001;

export function calcularRestoEnOrigen(producida, distribucionPorAlmacen = {}) {
  const total = Object.values(distribucionPorAlmacen).reduce((acc, q) => acc + Number(q || 0), 0);
  return Math.max(0, Number(producida || 0) - total);
}

export function validarDistribucion(platosRows, distribucionPorProducto, warehousesDestino) {
  if (!warehousesDestino?.length) {
    return { ok: false, message: 'No hay otros almacenes activos para distribuir.' };
  }

  let tieneCantidad = false;

  for (const row of platosRows) {
    const productId = String(row.product_id);
    const producida = Number(row.quantity || 0);
    const porAlmacen = distribucionPorProducto[productId] || {};
    const totalDistribuido = Object.values(porAlmacen).reduce((acc, q) => acc + Number(q || 0), 0);

    if (totalDistribuido > producida + QTY_EPS) {
      return {
        ok: false,
        message: `La distribución de "${row.receta_name || row.product_id}" supera la cantidad producida (${producida}).`,
      };
    }

    if (totalDistribuido > QTY_EPS) {
      tieneCantidad = true;
    }
  }

  if (!tieneCantidad) {
    return { ok: false, message: 'Indique al menos una cantidad a distribuir en otro almacén.' };
  }

  return { ok: true, message: '' };
}

export function buildDistribucionPayload(platosRows, distribucionPorProducto, productUnitById = {}) {
  const payload = [];

  for (const row of platosRows) {
    const productId = String(row.product_id);
    const porAlmacen = distribucionPorProducto[productId] || {};
    const canonicalUnit =
      productUnitById[productId] ||
      (row.unit_of_measure && String(row.unit_of_measure).toLowerCase() === 'unidad' ? 'UN' : row.unit_of_measure) ||
      (row.output_unit_of_measure && String(row.output_unit_of_measure).toLowerCase() === 'unidad'
        ? 'UN'
        : row.output_unit_of_measure) ||
      'UN';

    for (const [warehouseId, qty] of Object.entries(porAlmacen)) {
      const quantity = Number(qty || 0);
      if (quantity <= QTY_EPS) continue;
      payload.push({
        product_id: Number(row.product_id),
        warehouse_id: Number(warehouseId),
        quantity,
        unit_of_measure: canonicalUnit,
        description: row.receta_name || null,
      });
    }
  }

  return payload;
}

export function initDistribucionPorProducto(platosRows) {
  const map = {};
  for (const row of platosRows) {
    if (row.product_id != null) {
      map[String(row.product_id)] = {};
    }
  }
  return map;
}
